import i18n from "@apps/Shared/translation/i18n";
import { validateZipCode as validateOrderAssetZipCode } from "@apps/Shared/Blocks/ExtraPickupFormBlock/ExtraPickupForm/validation";
import { FormErrorType } from "@sharedComponents/PantaForm/types";
import {
    validateIsEmail,
    validateRequired
} from "@sharedComponents/PantaForm/utils";

export const validateEmail = (
    email: string,
    currentErrors: FormErrorType[]
) => {
    let errors = validateRequired(
        email,
        "email",
        i18n.t("error.emptyEmail"),
        currentErrors
    );

    if (email) {
        errors = validateIsEmail(
            email,
            "email",
            i18n.t("error.incorrectEmail"),
            errors
        );
    }

    return errors;
};

export const validatePostalCode = (
    postalCode: string,
    currentErrors: FormErrorType[]
) => {
    return validateOrderAssetZipCode(postalCode, currentErrors);
};
